import React from "react";
import point from "./../../../../../Images/point.png";

const TrendyHairHighlightChocolate = () => {
  return (
    <div className="blogWhat-content">
      <h5>7. Chocolate Brown with Cinnamon Highlights 🍂</h5>
      <p>
        For those who love warm, earthy tones, chocolate brown with cinnamon
        highlights is a match made in heaven. This hair highlights color adds
        dimension and warmth while maintaining a natural look.
      </p>
      <ul>
        <h4>Why It’s Trending:</h4>
        <li>
          <span>
            <img src={point} alt="point" />
            Soft and elegant{" "}
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Perfect for fall and winter vibes
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Enhances natural brown hair
            beautifully
          </span>
        </li>
      </ul>
    </div>
  );
};

export default TrendyHairHighlightChocolate;
